<template>
  <nav class="dashboard_menu">
    <div class="nav nav-tabs" role="tablist">
      <router-link
          :to="{ name: 'dashboardHeadAMDLInfo'}"
          :class="{ active: $route.name === 'dashboardHeadAMDLInfo' }"
          class="nav-item nav-link" role="tab">
        {{ $t('dashboard.tabs.info') }}
      </router-link>
      <router-link
          :to="{ name: 'dashboardHeadAMDLCoaches' }"
          :class="{ active: $route.name === 'dashboardHeadAMDLCoaches' }"
          class="nav-item nav-link" role="tab">
        {{ $t('dashboard.tabs.coaches') }}
      </router-link>
      <router-link
          :to="{ name: 'dashboardHeadAMDLPotentialUnits' }"
          :class="{ active: $route.name === 'dashboardHeadAMDLPotentialUnits' }"
          class="nav-item nav-link" role="tab">
        {{ $t('dashboard.tabs.preview_units_locations') }}
      </router-link>
      <router-link
          :to="{ name: 'dashboardHeadAMDLUnitsDoneByLocation' }"
          :class="{ active: $route.name === 'dashboardHeadAMDLUnitsDoneByLocation' }"
          class="nav-item nav-link" role="tab">
        {{ $t('dashboard.tabs.filterLocation') }}
      </router-link>
    </div>
  </nav>
</template>

<script setup>

import {RouterLink} from "vue-router";
</script>

<style scoped>

</style>